<!--
 * @Author: your name
 * @Date: 2020-08-21 18:00:15
 * @LastEditTime: 2020-09-04 12:53:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/compontens/upload.vue
-->
<template>
  <el-dialog :title="title" :visible.sync="visible" width="800px" append-to-body :close-on-click-modal="false">
    <div class="container">
      <div class="upload-tem">
        <span class="underline">请下载模板</span>
      </div>
      <el-upload
        class="fs-bi-upload"
        ref="upload"
        :action="uploadUrl"
        :multiple="false"
        :before-upload="beforeUploadHandle"
        :on-success="successHandle"
        :limit="1"
        :headers="baseHeaders"
        :show-file-list="false"
        :data="data"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <!-- <el-button type="info">
          <i class="el-icon-upload"></i>
          {{ $t("788") }}
        </el-button> -->
      </el-upload>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="visible = false">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { baseHeaders } from 'util/axios-request'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  props: {
    title: String
  },
  data() {
    return {
      visible: false,
      uploadUrl: baseURL + 'web/staff/importStaff',
      data: {},
      baseHeaders: baseHeaders()
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    beforeUploadHandle(file) {
      this.data.file_name = file
      return file
    },
    successHandle(res) {
      this.$refs.upload.clearFiles()
      this.$emit('getDepUser')
      this.$confirm(
        this.$t('43', {
          x: res.data.insert_count,
          y: res.data.update_count,
          z: res.data.error_count
        }),
        this.$t('229'),
        {
          showCancelButton: false,
          confirmButtonText: this.$t('131'),
          type: 'success'
        }
      )
      window.open(res.data.down_load_excel.object_url)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  .upload-tem {
    margin-bottom: 20px;
  }
  .upload-res {
    margin-top: 20px;
    text-align: center;
    p {
      margin-bottom: 5px;
    }
  }
  .underline {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
